import sprite from './sprite.js'; //Генератор svg спрайта
import Media from './mediaDetect.js'; //Детектор медиа
import 'jarallax/dist/jarallax.min.js';
import 'jarallax/dist/jarallax-element.min.js';

import Selects from './components/selects.js';
import RequestForm from './components/form.js';
import Tabs from './components/tabs.js';
import Accordion from './components/accordion.js';
import NewsSubscription from './components/news-subscription.js';
import Header from './components/header.js';
import Sidenav from './components/sidenav.js';
import Search from './components/search.js';
import Popup from './components/popup.js';
import Main from './components/main.js';
import TypicalSlider from './components/typical-slider.js';
import OnlineApplication from './components/online-application.js';
import Reports from './components/reports.js';
import Gallery from './components/gallery.js';
import Subsidiaries from './components/subsidiaries.js';
import Partners from './components/partners.js';
import About from './components/about.js';
import Awards from './components/awards.js';
import Map from './components/map.js';
import Calendar from './components/calendar.js';
import LiveSearch from './components/live-search.js';
import CalendarInputInterval from './components/calendar-input-interval.js';
import TerritoryComplex from './components/territory-complex.js';
// import TerritoryComplex from './components/territory-complex-old.js';
import TableScroll from './components/table-scroll.js';
import Exhibition from './components/exhibition.js';
import Congratulation from './components/congratulation.js';

import './components/guideline.js';

// Pages
import Events from './pages/events.js';
import News from './pages/news.js';
import Fairgrounds from './pages/fairgrounds.js'


$(document).ready(function() {

	// id языка глобально для всех скриптов
	//window.langId = $('[data-lang-id]').data('lang-id');

    $('.nano').nanoScroller();

    let btnNoteToggle = $('[data-btn-note-toggle]');
    if (btnNoteToggle.length) {

        btnNoteToggle.closest('[data-note-toggle]').each(function( index ) {
            let _this = $(this);

            if(_this.hasClass('open')){
                _this.find('[data-content-note-toggle]').show();
            }
        });
    }
    $('.main').on('click', '[data-btn-note-toggle]', function(){

        let _this = $(this),
            currContainer = _this.closest('[data-note-toggle]'),
            currContent = currContainer.find('[data-content-note-toggle]');

        currContainer.toggleClass('open');

        if(currContainer.hasClass('open')) {
            currContent.stop().slideDown();
        }else{
            currContent.stop().slideUp();
        }
    });

    let btnAttentionToggle = $('[data-btn-attention-toggle]');
    if (btnAttentionToggle.length) {

        btnAttentionToggle.closest('[data-attention-toggle]').each(function( index ) {
            let _this = $(this);

            if(_this.hasClass('open')){
                _this.find('[data-content-attention-toggle]').show();
            }
        });
    }
    $('.main').on('click', '[data-btn-attention-toggle]', function(){

        let _this = $(this),
            currContainer = _this.closest('[data-attention-toggle]'),
            currContent = currContainer.find('[data-content-attention-toggle]');

        currContainer.toggleClass('open');

        if(currContainer.hasClass('open')) {
            currContent.stop().slideDown();
        }else{
            currContent.stop().slideUp();
        }
    });

	// stop click disabled link
    $('body').on('click', 'a.btn, a.btn-arrow, a.btn-plus, a.btn-dropdown', function(event){
        if($(this).hasClass('disabled')){
            event.preventDefault();
        }
    });

    let popupImg = $('.js-popup-link');
    if(popupImg.length) {
        popupImg.magnificPopup({
            type:'inline',
            midClick: true,
            showCloseBtn: false
        });

        $('body').on('click', '.js-close-popup', function(e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
    }

    /*let iframe = $('iframe');
    if(iframe.length) {

        iframe.each(function( index ) {
            let _this = $(this),
                currLink = _this.attr('src');

            if(currLink.indexOf("youtu") >= 0) {
                var arrLink =  currLink.split("?");

                if(arrLink.length == 1) {
                    _this.attr('src', currLink + '?rel=0');
                }
                if(arrLink.length > 1) {
                    if(currLink.indexOf('rel') >= 0){
                        _this.attr('src', currLink.replace('rel=1', 'rel=0'));
                    }else{
                        _this.attr('src', currLink + '&rel=0');
                    }
                }
            }
        });
    }*/

    if ( !$.cookie('cookie-read') ) {
        $('[data-cookie-message]').show();
    }
    $('[data-cookie-message-close]').on('click', function(){
        $('[data-cookie-message]').hide();
        $.cookie('cookie-read', 'true', { expires: 365 });
    });


    let topHeaderBanner = $('[data-top-head-banner]');
    if(topHeaderBanner.length) {
        $('[data-page-wrapper]').addClass('page-wrapper__top-banner');
    }
})



// WEBPACK FOOTER //
// ./index.js